import { SeoMetaTypeEnum } from '@is24at/react-enums';
import { SearchParamsEnum } from 'utils/enums';
import SeoRules, { PREPOSITION_PLACEHOLDER } from './classes/SeoRules';
import SeoTemplate from './classes/SeoTemplate';

const titleTemplate = new SeoTemplate(
  SeoMetaTypeEnum.TITLE,
  `Immobilienmakler %(${PREPOSITION_PLACEHOLDER})s %(${SearchParamsEnum.spot})s finden - ImmoScout24`,
);
const metaDescriptionTemplate = new SeoTemplate(
  SeoMetaTypeEnum.META_DESCRIPTION,
  `Immobilienmakler %(${PREPOSITION_PLACEHOLDER})s %(${SearchParamsEnum.spot})s: Bei ImmoScout24 finden Sie den passenden Makler, Immobilienvermittler und Immobilienberater für %(${SearchParamsEnum.spot})s.`,
);
const headerTemplate = new SeoTemplate(
  SeoMetaTypeEnum.HEADER,
  `Immobilienmakler %(${PREPOSITION_PLACEHOLDER})s %(${SearchParamsEnum.spot})s`,
);

export default new SeoRules(
  titleTemplate,
  metaDescriptionTemplate,
  headerTemplate,
);
